export default "__VITE_ASSET__7f20b0eb__"